import './additionals.scss';

import { useField, useFormikContext } from 'formik';
import { ClipboardEvent, DragEvent, KeyboardEvent, memo, SyntheticEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { FaMinus, FaPlus } from 'react-icons/fa';

import { useOptionContext } from '@/resources/hooks/useOptionsContext';

import { ICartItemValues } from '../../../../../store/ducks/order/types';
import OptionPrice from '../OptionPrice';

function Additionals() {
  const { answer, optionIndex, selectOptionIndex, maxOfAnswers } = useOptionContext();
  const { values, setFieldValue } = useFormikContext<ICartItemValues>();

  const [field, { value: quantity }] = useField({
    type: 'hidden',
    value: values.options[optionIndex]?.select_options[selectOptionIndex]?.quantity,
    name: `options.${optionIndex}.select_options.${selectOptionIndex}.quantity`,
  });

  const validateMaxOfAnswers = () => {
    let answers = 0;

    values.options[optionIndex]?.select_options.forEach((answer) => {
      answers += parseInt(answer.quantity);
    });

    return maxOfAnswers <= answers;
  };

  const isDisabled = validateMaxOfAnswers();

  return (
    <div className="d-flex align-items-center justify-content-between my-2">
      <div className="d-flex align-items-center">
        <div
          id="additional-answer"
          className="input-group input-group-sm"
          style={{ width: 120, minWidth: 120 }}
        >
          <div className="input-group-prepend">
            <button
              id={`decrement-quantity-${answer.question_id}-${answer.id}`}
              className="btn btn-primary"
              aria-label="Diminuir quantidade"
              onClick={() => {
                setFieldValue(
                  `options.${optionIndex}.select_options.${selectOptionIndex}.quantity`,
                  (parseInt(quantity) - 1).toString(),
                );
              }}
              aria-describedby={`answer-${answer.id}`}
              type="button"
              disabled={quantity <= 0 || isDisabled}
            >
              <FaMinus size="10pt" />
            </button>
          </div>

          <FormControl
            {...field}
            draggable={false}
            autoComplete="off"
            value={quantity}
            disabled={isDisabled}
            max={answer.maximum_quantity}
            type="number"
            inputMode="numeric"
            className="additional-quantity-input"
            onClick={(e: SyntheticEvent<HTMLInputElement>) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
              e.stopPropagation();
              if (e.key === 'Enter') e.preventDefault();
            }}
            onDrop={(e: DragEvent<HTMLInputElement>) => e.preventDefault()}
            onPaste={(e: ClipboardEvent<HTMLInputElement>) => e.preventDefault()}
          />

          <div className="input-group-append">
            <button
              id={`increment-quantity-${answer.question_id}-${answer.id}`}
              onClick={() => {
                setFieldValue(
                  `options.${optionIndex}.select_options.${selectOptionIndex}.quantity`,
                  (parseInt(quantity) + 1).toString(),
                );
              }}
              className="btn btn-primary"
              aria-label="Aumentar quantidade"
              aria-describedby={`answer-${answer.id}`}
              type="button"
              disabled={quantity >= answer.maximum_quantity || isDisabled}
            >
              <FaPlus size="9pt" />
            </button>
          </div>
        </div>

        <span className="title-label answer-title mb-0 h5 text-break mx-2">{answer.title}</span>
      </div>

      <div>
        <OptionPrice quantity={parseInt(quantity)} showSubtotal={true} />
      </div>
    </div>
  );
}

export default memo(Additionals);
